import { StateCreator } from 'zustand';
import { IKybSlice, KybData } from './kyb.types.ts';
import { getKybModel } from './kyb.service.ts';

export const createKybSlice: StateCreator<IKybSlice> = (set, get) => ({
  kybData: getKybModel(),
  setKybData: (kybData: KybData) => {
    set(() => ({ kybData: kybData }));
  },
  getKybData: () => get().kybData,
});
